// extracted by mini-css-extract-plugin
export default {"wrapper":"InfoBlobWithIcon_wrapper__xHD7U","icon":"InfoBlobWithIcon_icon__keCx7","info":"InfoBlobWithIcon_info__2X1NR"};